import { render, staticRenderFns } from "./EventIsClosed.vue?vue&type=template&id=3d47a902&scoped=true"
import script from "./EventIsClosed.vue?vue&type=script&lang=js"
export * from "./EventIsClosed.vue?vue&type=script&lang=js"
import style0 from "./EventIsClosed.vue?vue&type=style&index=0&id=3d47a902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d47a902",
  null
  
)

export default component.exports